import i18n from "@/plugins/vue-i18n";

const Creatives = () =>
  import(/* webpackChunkName: "creatives" */ "@/views/advert/creatives/CreativeIndexPage.vue");

const CreativeAdd = () =>
  import(/* webpackChunkName: "creatives" */ "@/views/advert/creatives/CreativeAddPage.vue");

const CreativeEdit = () =>
  import(/* webpackChunkName: "creatives" */ "@/views/advert/creatives/edit/CreativeEditPage.vue");

const creatives = [
  {
    path: "/creatives",
    name: "Creatives",
    component: Creatives,
    meta: {
      title: i18n.t("title.creatives"),
    },
  },
  {
    path: "/creatives/add",
    name: "CreativeAdd",
    component: CreativeAdd,
    meta: {
      title: i18n.t("title.creativeAdd"),
    },
  },
  {
    path: "/creatives/:id/edit",
    name: "CreativeEdit",
    component: CreativeEdit,
    meta: {
      title: i18n.t("title.creative"),
    },
  },
];

export default creatives;
